import React from 'react';
import PropTypes from 'prop-types';

import Popup from 'components/Popup';

export default function SpreadPopup({ isPopupOpen, setIsPopupOpen }) {
  const closePopup = () => setIsPopupOpen(false);

  return (
    isPopupOpen && (
      <Popup closePopup={closePopup}>
        <h2 className='mb-4'>What is a &quot;spread&quot;?</h2>
        <p>
          Your spread is determined by the difference between the FMV (fair market value) of your shares at exercise and the grant price
          (original price of each share). This amount will determine how much you&apos;ll be subjected to when you&apos;ll pay upon
          exercising your options.
        </p>
      </Popup>
    )
  );
}

SpreadPopup.propTypes = {
  isPopupOpen: PropTypes.bool,
  setIsPopupOpen: PropTypes.func
};
